module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image20c.c5ea7a29.jpg";